export enum Labels {
  DOMAIN_NAME = 'Domain name',
  CANTON_IMAGE = 'Canton image',
  IMAGE_PULL_SECRET = 'Image pull secret',
  ENABLE_DAEMON_MODE = 'Enable Daemon mode',
  ENABLE_ENTERPRISE = 'Enable Enterprise',
  ENABLE_INGRESS = 'Enable Ingress',
  REQUESTED_CPU = 'Requested CPU',
  CPU_LIMIT = 'CPU limit',
  REQUESTED_MEMORY = 'Requested memory',
  MEMORY_LIMIT = 'Memory limit',
  REPLICAS = 'Replicas',
  TOPOLOGY = 'Topology',
  BOOTSTRAP = 'Bootstrap',
  ENV_VARS = 'Environment variables',
  SECRET_NAME = 'Secret name',
  SECRET_KEY = 'Secret key',
  ADMIN_PORT = 'Admin port',
  PUBLIC_PORT = 'Public port',
  LEDGER_PORT = 'Ledger port',
  LEDGER_ADDRESS = 'Ledger address',
  LEDGER_ID = 'Ledger ID',
  STORAGE_TYPE = 'Storage type',
  STORAGE_USER = 'User',
  STORAGE_HOSTNAME = 'Hostname',
  STORAGE_PORT = 'Port',
  STORAGE_SIZE = 'Size',
  STORAGE_BACKUP_SIZE = 'Backup size',
  ADMIN_ADDRESS = 'Admin address',
  PUBLIC_ADDRESS = 'Public address',
  LOG_LEVEL = 'Log level',
  NAME = 'Name',
  IMAGE_TAG = 'Image tag',
  IMAGE_REPO = 'Image repo',
  DATABASE_TYPE = 'Database type',
  POSTGRESQL = 'PostgreSQL',
  EXTERNAL_DATABASE = 'External database',
  DATABASE_USER = 'Database user',
  DATABASE_PASSWORD = 'Database password',
  DATABASE_HOSTNAME = 'Host/IP address',
  DATABASE_PORT = 'Port number',
  DISABLE_WALLET = 'Disable wallet',
  FAIL_ON_APP_VERSION_MISMATCH = 'Fail on app version mismatch',
  USE_SEQUENCER_CONNECTIONS_FROM_SCAN = 'Use sequencer connections from scan',
  SCAN_ADDRESS = 'Scan address',
  SV_SPONSOR_ADDRESS = 'SV Sponsor Address',
  DEFAULT_JVM_OPTIONS = 'Default JVM Options',
  PARTY_HINT = 'Party hint',
  ATTACH_PVC = 'Attach PVC',
  MIGRATING = 'Migrating',
  TOP_UP_ENABLE = 'Top up enable',
  TOP_UP_MIN_INTERVAL = 'Min Top up interval',
  TOP_UP_TARGET_THROUGHPUT = 'Target throughput',
  DISABLE_AUTO_INIT = 'Disable auto init',
  NODE_IDENTIFIER = 'Node identifier',
  IDENTITIES_DUMP_IMPORT = 'Restore participant identities',
  IDENTITIES_DUMP_BACKUP = 'Participant identities dump periodic backup',
  BACKUP_INTERVAL = 'Back up interval',
  BACKUP_HISTORY = 'Backup history',
  LOCATION_BUCKET_NAME = 'Location bucket name',
  LOCATION_BUCKET_PROJECT_ID = 'Location bucket project id',
  LOCATION_BUCKET_SECRET_NAME = 'Location bucket secret name',
  LOCATION_PREFIX = 'Location prefix name',
  ONBOARD_SECRET = 'Onboard secret',
  PARTICIPANT_NODE = 'Participant node',
  VALIDATOR_BACKEND = 'Validator backend',
  CNS_UI = 'Canton Name Service UI',
  WALLET_UI = 'Wallet UI',
  TOP_UP = 'Top up',
  MIGRATION = 'Migration',
  MIGRATION_ID = 'Migration id',
  ID = 'Id',
  MAIN_SETTINGS = 'Main settings',
  ENV_VARIABLES = 'Environment variables',
  ENV_VARIABLES_OVERRIDE = 'Environment variables override',
  SUMMARY = 'Summary',
  CLUSTER_CONFIG = 'Cluster configuration',
  CLUSTER_PARTICIPANT_CONFIG = 'Cluster participant configuration',
  OPTIONAL = 'Optional',
  APPLICATION_NAME = 'Application name',
  APPLICATION_TYPE = 'Application type',
  UI = 'UI',
  BACKEND = 'Backend',
  FILE = 'File',
  PUBLIC_URL = 'Public url',
  SUBDOMAIN = 'Subdomain',
  CUSTOM_SUBDOMAIN = 'Custom subdomain',
  PARTICIPANT_SUBDOMAIN = 'Participant subdomain',
  PORT = 'Port',
  PARTICIPANT_NAME = 'Participant name',
  ENABLE_NAVIGATOR = 'Enable navigator',
  ENABLE_AUTH_SERVICE = 'Enable Authorization service',
  ENABLE_JSON_API_QUERY_STORE_DATABASE = 'JSON API Query Store Database ',
  AUTHENTICATION_PROVIDER = 'Authentication Provider',
  REMOTE_PARTICIPANT_NAME = 'Remote participant name',
  JSON_API_URL = 'JSON API URL',
  RESOURCES = 'Resources',
  MIGRATE_VALIDATOR_PARTY = 'Migrate Validator Party',
  IDENTITIES_SECRET_NAME = 'Secret name',
  NEW_PARTICIPANT_IDENTIFIER = 'New participant node identifier',
  IMAGE = 'Image',
  MODE = 'Mode',
  TYPE = 'Type',
  NAVIGATOR = 'Navigator',
  AUTHORIZATION_SERVICE = 'Authorization service',
  APPLICATION = 'Application',
  APPLICATION_WALLET = 'Application wallet',
  APPLICATION_CNS = 'Application CNS',
  DOMAIN = 'Domain',
  PARTICIPANT = 'Participant',
  PACKAGE_NAME = 'Package name',
  VALIDATOR_WALLET_PASSWORD = 'Validator wallet user password',
  VALIDATOR_RESOURCES = 'Validator resources',
  APPLICATION_CNS_RESOURCES = 'CNS resources',
  APPLICATION_WALLET_RESOURCES = 'Info wallet resources',
  VALIDATOR_PARTICIPANT_RESOURCES = 'Participant resources',
  CUSTOM_AUTH = 'Custom authentication',
  CNS_CLIENT_ID = 'CNS Client Id',
  WALLET_CLIENT_ID = 'Wallet Client Id',
  LEDGER_API_CLIENT_ID = 'Ledger API Client Id',
  LEDGER_API_CLIENT_SECRET = 'Ledger API Client Secret',
  LEDGER_API_USER = 'Ledger API User',
  WALLET_USER = 'Wallet User',
  AUDIENCE = 'Audience',
  DARS = 'DAR files',
  USERS = 'Users',
  PARTIES = 'Parties',
  LOCAL_PARTIES = 'Local Parties',
  COMMAND = 'Command',
  LOGS = 'Logs',
  APPLICATIONS = 'Applications',
  COLLECTIONS = 'Collections',
  DOMAINS = 'Domains',
  REMOTE_DOMAINS = 'Remote domains',
  PARTICIPANTS = 'Participants',
  REMOTE_PARTICIPANTS = 'Remote participants',
  VALIDATORS = 'Validators',
  VERSION = 'Version',
  DASHBOARD = 'Dashboard',
  DAR_COLLECTIONS = 'DAR collections',
  UI_COLLECTIONS = 'UI collections',
  PRIVATE_JSON_API = 'Private JSON API',
  KMS = 'KMS',
  ENABLE_KMS = 'Enable KMS',
  KMS_DRIVER = 'KMS Driver',
  KMS_VALUE = 'KMS Value',
  KMS_SERVICE_ACCOUNT = 'KMS Service Account',
  KMS_AZURE_VAULT_SECRET_NAME = 'KMS Azure Vault Secret Name',
  PARTICIPANT_IMAGE_OVERRIDE = 'Participant image override',
  PARTICIPANT_IMAGE_PULL_SECRET = 'Participant image pull secret',
  RESET_TO_DEFAULTS = 'Reset to defaults',
  DOMAIN_URL = 'Domain URL',
  DOMAIN_ALIAS = 'Domain alias',
  CUSTOM_DOMAIN = 'Custom domain',
  CONNECT_TO_DOMAIN = 'Connect to domain',
  PRIMARY_PARTY = 'Primary party',
  USERNAME = 'User name',
  PARTY_ID = 'Party id',
  RESTORE = 'Restore',
  REMOVE_RESTORE_CONFIG = 'Remove restore configuration',
  DISPLAY_NAME = 'Display name',
  IDENTIFIER_HINT = 'Identifier hint',
  WALLET = 'Wallet',
  DEV_NET = 'DevNet',
  TEST_NET = 'TestNet',
  MAIN_NET = 'MainNet',
  SPONSOR_SV_NAME = 'Sponsor SV name',
  SCAN_API = 'Scan API',
  JSON_API_ADDRESS = 'JSON API Address',
  LEDGER_API_ADDRESS = 'Ledger API Address',
  EXPOSE_LEDGER_API = 'Expose Ledger API',
  CONTACT_POINT = 'Contact point',
  DISABLE_PROBES = 'Disable probes',
  MANAGEMENT = 'Management',
  CONNECT_PARTICIPANT_TO_DOMAIN_FIRST = 'Connect participant to domain first',
  NEXT_RUN = 'Next run',
  VALIDATOR_API = 'Validator API',
  REMOVE_RIGHT = 'Remove right',
}
